const STORAGE_KEY = "boiler-simulator-answers";

const RESULT_RULES = [
  { product: "kf", answers: ["a31"] },
  { product: "kf", answers: ["a21", "a32", "a42"] },
  { product: "kf", answers: ["a22", "a32"] },
  { product: "willheat", answers: ["a21", "a32", "a41"] },
  { product: "willheat", answers: ["a21", "a33", "a41", "a52"] },
  { product: "ifrit", answers: ["a21", "a33", "a41", "a51"] },
  { product: "ifrit", answers: ["a21", "a33", "a42"] },
  { product: "ifrit", answers: ["a22", "a33"] },
];

export default function initBoilerSimulator() {
  const root = document.getElementById("js-boiler-simulator");
  if (!root) return;

  const screens = {
    top: root.querySelector('[data-simulator-screen="top"]'),
    question: root.querySelector('[data-simulator-screen="question"]'),
    result: root.querySelector('[data-simulator-screen="result"]'),
  };
  const startButton = root.querySelector(".js-boiler-simulator-start");
  const questionLabel = root.querySelector(".js-boiler-simulator-question-label");
  const questionText = root.querySelector(".js-boiler-simulator-question-text");
  const questionNote = root.querySelector(".js-boiler-simulator-question-note");
  const optionsRoot = root.querySelector(".js-boiler-simulator-options");
  const resultPanels = root.querySelectorAll("[data-simulator-result]");
  const summaryList = root.querySelector(".js-boiler-simulator-summary");
  const backButton = root.querySelector(".js-boiler-simulator-back");
  const retryButton = root.querySelector(".js-boiler-simulator-retry");

  const questions = JSON.parse(root.getAttribute("data-questions") || "[]");
  const results = JSON.parse(root.getAttribute("data-results") || "{}");

  if (!screens.top || !screens.question || !screens.result || questions.length === 0) return;

  const loadAnswers = () => {
    try {
      const stored = sessionStorage.getItem(STORAGE_KEY);
      return stored ? JSON.parse(stored) : [];
    } catch {
      return [];
    }
  };

  let currentIndex = 0;
  let answers = loadAnswers();

  const showScreen = (name) => {
    Object.entries(screens).forEach(([key, screen]) => {
      if (!screen) return;
      const isActive = key === name;
      screen.hidden = !isActive;
      screen.classList.toggle("is-active", isActive);
    });
    root.classList.toggle("is-question", name === "question");
    root.classList.toggle("is-result", name === "result");
  };

  const saveAnswers = () => {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(answers));
  };

  const resetAnswers = () => {
    answers = [];
    sessionStorage.removeItem(STORAGE_KEY);
  };

  const getProductId = () => {
    const selected = answers.map((item) => item.id);
    const rule = RESULT_RULES.find((item) =>
      item.answers.every((answerId) => selected.includes(answerId)),
    );
    return rule?.product ?? null;
  };

  const renderQuestion = () => {
    const question = questions[currentIndex];
    if (!question) return;

    questionLabel.textContent = question.label;
    questionText.textContent = question.question;

    if (question.note) {
      questionNote.textContent = question.note;
      questionNote.hidden = false;
    } else {
      questionNote.textContent = "";
      questionNote.hidden = true;
    }

    optionsRoot.innerHTML = "";

    const currentAnswer = answers.find((item) => item.step === question.step);

    question.options.forEach((option) => {
      const button = document.createElement("button");
      button.type = "button";
      button.className = "p-boiler-simulator-option";
      if (currentAnswer?.id === option.id) {
        button.classList.add("is-selected");
      }
      button.textContent = option.label;
      button.addEventListener("click", () => {
        answers = answers.filter((item) => item.step !== question.step);
        answers.push({
          step: question.step,
          id: option.id,
          title: option.title,
        });
        saveAnswers();

        if (currentIndex < questions.length - 1) {
          currentIndex += 1;
          renderQuestion();
          return;
        }

        renderResult();
      });
      optionsRoot.appendChild(button);
    });
  };

  const renderResult = () => {
    const productId = getProductId() ?? "none";
    const heading = root.querySelector(".p-boiler-simulator-result__heading");
    if (heading) {
      heading.style.display = productId === "none" ? "none" : "";
    }

    resultPanels.forEach((panel) => {
      const isMatch = panel.dataset.simulatorResult === productId;
      panel.hidden = !isMatch;
      panel.classList.toggle("is-active", isMatch);
    });

    if (summaryList) {
      summaryList.innerHTML = "";
      answers.forEach((answer) => {
        const item = document.createElement("li");
        item.className = "p-boiler-simulator-summary__item";
        item.innerHTML = `<span class="p-boiler-simulator-summary__label">設問${answer.step}：</span><span class="p-boiler-simulator-summary__value">${answer.title}</span>`;
        summaryList.appendChild(item);
      });
    }

    showScreen("result");
    screens.result?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  startButton?.addEventListener("click", () => {
    resetAnswers();
    currentIndex = 0;
    renderQuestion();
    showScreen("question");
  });

  backButton?.addEventListener("click", () => {
    if (answers.length > 0) {
      answers.pop();
      saveAnswers();
    }
    currentIndex = Math.max(questions.length - 1, 0);
    renderQuestion();
    showScreen("question");
  });

  retryButton?.addEventListener("click", () => {
    resetAnswers();
    currentIndex = 0;
    showScreen("top");
    screens.top?.scrollIntoView({ behavior: "smooth", block: "start" });
  });

  showScreen("top");
}
